module.exports = __webpack_public_path__ + "static/media/spinner-dogs-allowed.edc4ccbb.gif";